"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketTtsClientMessageMulti = void 0;
const core = __importStar(require("../../core"));
const RealtimeVoiceSettings_1 = require("./RealtimeVoiceSettings");
const GenerationConfig_1 = require("./GenerationConfig");
const PronunciationDictionaryLocator_1 = require("./PronunciationDictionaryLocator");
exports.WebsocketTtsClientMessageMulti = core.serialization.object({
    text: core.serialization.string().optional(),
    voiceSettings: core.serialization.property("voice_settings", RealtimeVoiceSettings_1.RealtimeVoiceSettings.optional()),
    generationConfig: core.serialization.property("generation_config", GenerationConfig_1.GenerationConfig.optional()),
    xiApiKey: core.serialization.property("xi-api-key", core.serialization.string().optional()),
    authorization: core.serialization.string().optional(),
    flush: core.serialization.boolean().optional(),
    pronunciationDictionaryLocators: core.serialization.property("pronunciation_dictionary_locators", core.serialization.list(PronunciationDictionaryLocator_1.PronunciationDictionaryLocator).optional()),
    contextId: core.serialization.string().optional(),
    closeContext: core.serialization.property("close_context", core.serialization.boolean().optional()),
    closeSocket: core.serialization.property("close_socket", core.serialization.boolean().optional()),
});
